import Swiper, { Navigation, Scrollbar, Mousewheel } from 'swiper';

const classes = {
  wrapperCenter: 'swiper-wrapper--center',
};

const heroCarousel = () => ({
  selectedIdx: 0, // tabbed navigation only

  /**
   * Centers the wrapper swiper fully fits in container.
   */
  swiperCenterOnNoScroll: (swiper) => {
    const isSwipeable = swiper.virtualSize > swiper.size;

    if (!isSwipeable) {
      swiper.wrapperEl?.classList.add(classes.wrapperCenter);
    } else {
      swiper.wrapperEl?.classList.remove(classes.wrapperCenter);
    }
  },

  cacheNodes() {
    this.swiperEl = this.$refs.cardsSwiper;
    this.tabsSwiperEl = this.$refs.tabsSwiper;
  },

  buildSwipers() {
    const tabsSwiperConfig = {
      slidesPerView: 'auto',
      on: {
        ppClick: (_, event) => {
          this.selectedIdx = Number(event.target.dataset.index);
          this.swiperInstance.slideTo(this.selectedIdx, 250);
          this.tabsSwiperInstance.slideTo(this.selectedIdx, 250);
        },
        init: this.swiperCenterOnNoScroll,
        resize: this.swiperCenterOnNoScroll,
      },
    };
    // Tabs setup -- Tabbed Navigation
    if (this.tabsSwiperEl) {
      this.tabsSwiperInstance = new Swiper(this.tabsSwiperEl, tabsSwiperConfig);
    }

    if (!this.swiperEl) {
      return;
    }

    // Main Swiper set up
    const swiperConfig = {
      slidesPerView: 'auto',
      modules: [Navigation, Mousewheel],
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.hero-carousel > .swiper > .swiper-button-next',
        prevEl: '.hero-carousel > .swiper > .swiper-button-prev',
      },
      grabCursor: true,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      on: {
        slideChange: (swiper) => {
          this.selectedIdx = swiper.activeIndex;
          if (this.tabsSwiperInstance) {
            this.tabsSwiperInstance.slideTo(this.selectedIdx, 250);
          }
        },
      },
    };

    // Includes scrollbar if HTML for it is present
    const scrollbarEl = this.$el.querySelector('.swiper-scrollbar');
    if (scrollbarEl) {
      swiperConfig.modules = swiperConfig.modules.concat([Scrollbar]);
      swiperConfig.scrollbar = {
        el: '.swiper-scrollbar',
        hide: true,
      };
    }

    this.swiperInstance = new Swiper(this.swiperEl, swiperConfig);
  },

  onShopifyBlockSelect({ event }) {
    const index = event.target?.dataset?.slideIndex;

    if (this.swiperInstance && typeof index !== 'undefined') {
      this.swiperInstance.slideTo(Number(index), 0);
    }
  },

  init() {
    this.cacheNodes();
    this.buildSwipers();
  },
});

export default heroCarousel;
